import i18n, { Module } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { ISearchParams, getParams } from './url.js';
import { environment } from './config/environment.ts';
import { sanitize } from './utils/sanitize.js';
import i18next from 'i18next';

declare module 'i18next' {
  // change from react-i18next to i18next
  interface CustomTypeOptions {
    returnNull: false;
    allowObjectInHTMLChildren: true; // add this solve my issue
  }
}

let i18nError = false;

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector as unknown as Module)
  .init(environment.i18n, (err: unknown) => {
    if (err) {
      i18nError = true;
      console.error(err as Error);
    }
  });

i18n.loadNamespaces(['login', 'registration']);

const params: ISearchParams = getParams(location.search);
const sanitizedParams: ISearchParams = JSON.parse(sanitize(JSON.stringify(params)));
const lang = sanitizedParams['lng'] || 'en';
document.documentElement.lang = lang === 'es' ? 'es' : 'en';
i18n.changeLanguage(lang);
window.digitalData?.someProperty;

i18next.language;
i18next.hasResourceBundle('en', 'translation');

export { i18nError };
export default i18n;

declare var digitalData: any;
declare var _satellite: any;
declare var OneTrust: any;
